import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { md3 } from 'vuetify/blueprints'

import { createVuetify } from 'vuetify'

const haskoningLight = {
  dark: false,
  colors: {
    background: '#FFFFFF',
    surface: '#FFFFFF',
    primary: '#009EAB',
    secondary: '#009EAB',
    highlight: '#CCECEE',
    speckleColor: '#047EFB'
  }
}

export default createVuetify({
  blueprint: md3,
  theme: {
    defaultTheme: 'haskoningLight',
    themes: {
      haskoningLight: haskoningLight
    }
  },
  defaults: {
    VTextField: {
      variant: 'filled'
    },
    VSelect: {
      variant: 'filled'
    },
    VTextarea: {
      variant: 'filled'
    },
    VBtn: {
      variant: 'flat',
      rounded: 'pill'
    }
  }
})
